import { useGetUserProfile } from './useGetUserProfile';
/**
 * Returns the active user from the `getUserProfile` cache.
 *
 * Convenience accessor that returns only the data from `useGetUserProfile`.
 * Use `useGetUserProfile` directly when loading/error state is also needed.
 *
 * @see src/platform-services/auth/user-profile.ts
 */
export const useActiveUser = () => {
    const { data } = useGetUserProfile();
    return data;
};
